import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'hoursSinceLastRoundtripPipe'
})
export class HoursSinceLastRoundtripPipe implements PipeTransform {
  private baseClass = 'fa fa-circle fa-1x ';

  transform(value: any, args?: any): string {
    const hoursSince: number = +value;
    let textColor = 'red-text';

    if (hoursSince < 24 ) {
      textColor = this.baseClass + 'green-text';
    } else if (hoursSince > 24 && hoursSince < 72 ) {
      textColor = this.baseClass + 'yellow-text';
    }

    return this.baseClass + textColor;
  }

}
